import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { IconComponent } from "@app/core";

import styles from "./cta-link-block.module.scss";

export type CtaLinkBlockProps = {
  title?: string;
  subtitle?: string;
  count?: number;
  url?: string;
  target?: string;
  className?: string;
};

const CtaLinkBlock = ({ title, subtitle, count, url, target, className }: CtaLinkBlockProps): JSX.Element => {
  const showCount = typeof count === "number";

  return (
    <Link className={clsx(styles.root, className)} to={url || ""} target={target}>
      <div className={styles.text}>
        {title && <span className={styles.title}>{title}</span>}
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
      <div className={clsx(styles.arrow, showCount && styles.withCount)}>
        {showCount && <span>{count}+</span>}

        <div className={styles.icon}>
          <IconComponent icon={IcnChevronRight} size="12px" />
        </div>
      </div>
    </Link>
  );
};

export { CtaLinkBlock };
